module.exports = __webpack_public_path__ + "static/camera-bg-1c71ac0cb7c22c329233c1721a16b17b.jpg";